var map = {
	"./Icon-email@3x.png": 3247,
	"./Icon-github-mark@3x.png": 3099,
	"./Icon-linkedin-mark@3x.png": 4012,
	"./Icon-twitter-mark@3x.png": 6080,
	"./close": 7323,
	"./close.js": 7323,
	"./email": 7451,
	"./email.js": 7451,
	"./github": 7609,
	"./github.js": 7609,
	"./instagram": 6101,
	"./instagram.js": 6101,
	"./linkedin": 6722,
	"./linkedin.js": 6722,
	"./svg/Icon-email@1.5x.svg": 1844,
	"./svg/Icon-github-mark@1.5x.svg": 6860,
	"./svg/Icon-linkedin-mark@1.5x.svg": 6666,
	"./svg/Icon-twitter-mark@1.5x.svg": 3416,
	"./svg/service-branding.svg": 5310,
	"./svg/service-datavis.svg": 6048,
	"./svg/service-editorial.svg": 2115,
	"./twitter": 5364,
	"./twitter.js": 5364
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5327;